/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Tags_NewInputs */

const cs_clients_tags_new = /** @type {(inputs: Clients_Tags_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nový štítek`)
};

const en_clients_tags_new = /** @type {(inputs: Clients_Tags_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New tag`)
};

/**
* | output |
* | --- |
* | "New tag" |
*
* @param {Clients_Tags_NewInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const clients_tags_new = /** @type {((inputs?: Clients_Tags_NewInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Tags_NewInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_tags_new(inputs)
	return cs_clients_tags_new(inputs)
});